import { StyledH2 } from "../styled/StyledH2";
//-------------------------------------------------

const PostHeadline = () => {
  return (
    <StyledH2>Pinnwand</StyledH2>
  )
}

export default PostHeadline;

